<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    :class="{ 'properties-field-group': onTable }"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Button</div>
        </h4>
        <div
          class="close-properties"
          @click="closeConfiguration"
        >
          &times;
        </div>

        <div class="wrap-type">
          <img
            src="@/assets/new-form-ui/icon/button.svg"
            height="32"
          >
          <div class="text-type">Action Button</div>
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content">
        <div class="section-field input-field">
          <b-row>
            <!-- Key Field -->
            <b-col cols="12">
              <b-form :class="{'error-input' : $v.dataSetup.key.$error}">
                <div class="title-field">
                  <label> Key </label>
                </div>
                <j-input
                  v-model="dataSetup.key"
                  placeholder="Enter button key"
                />
              </b-form>
            </b-col>

            <!-- Label Field -->
            <b-col cols="12">
              <b-form :class="{'error-input' : $v.dataSetup.label.$error}">
                <div class="title-field">
                  <label> Label </label>
                </div>
                <j-input
                  v-model="dataSetup.label"
                  placeholder="Enter button label"
                />
              </b-form>
            </b-col>
          </b-row>

          <!-- Icon -->
          <div
            v-if="!onTable"
            :class="{'error-input' : $v.dataSetup.icon_web.$error}"
            class="icon-configuration"
          >
            <p class="title">Icon</p>
            <p class="desc">Image that represents the action button.</p>

            <div class="wrap-icon">
              <div class="div-icon">
                <i
                  v-if="dataSetup.icon_web"
                  :class="`fa ${dataSetup.icon_web.includes('fa-') ? dataSetup.icon_web : 'fa-' + dataSetup.icon_web}`"
                />
              </div>
              <div class="ml-2">
                <p class="icon-name">{{ dataSetup.icon_web || 'None' }}</p>
                <p
                  class="icon-change"
                  @click="openModalIcon"
                >
                  Change
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="section-field input-field">
          <h4 class="title-section">Custom Actions</h4>

          <!-- Color -->
          <b-row
            v-if="onTable"
            class="m__b--15">
            <b-col md="6">
              <j-color-picker
                v-model="dataSetup.font_color"
                :color="dataSetup.font_color"
                label="Font Color"
                picker="chrome" />
            </b-col>
            <b-col md="6">
              <j-color-picker
                v-model="dataSetup.background_color"
                :color="dataSetup.background_color"
                label="Background Color"
                picker="chrome" />
            </b-col>
          </b-row>

          <!-- Action -->
          <div class="configuration-section">
            <div class="div-custom-action">
              <div class="wrap-left">
                <img
                  src="@/assets/new-form-ui/icon/script-action.svg"
                  class="icon"
                >
                <div>
                  <p class="title-div">
                    Action
                    <img
                      v-if="dataSetup.script || dataSetup.variable_message || dataSetup.variable_redirect"
                      src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
                    >
                  </p>
                  <p class="desc-div">
                    Actions to be executed overall logic on script
                  </p>
                </div>
              </div>

              <img
                src="@/assets/new-form-ui/setup.svg"
                class="open-modal"
                @click="openModalScript"
              >
            </div>
          </div>

          <!-- Type Configuration -->
          <!-- <div
            v-if="!onTable"
            class="configuration-section">
            <h4 class="configuration-section-title mb-2">Type</h4>

            <div class="d-flex align-items-center">
              <div
                v-for="option in typeOptions"
                :key="option.id"
                :class="{ 'active': option.id === dataSetup.type }"
                class="div-list-language"
                @click="dataSetup.type = option.id"
              >
                {{ option.name }}
              </div>
            </div>
          </div> -->

          <!-- Other Variable -->
          <div
            v-if="dataSetup.container_params || dataSetup.container_record"
            class="configuration-section"
          >
            <p class="configuration-section-title mb-2">Other Variable</p>

            <b-row>
              <b-col
                v-if="!onTable"
                cols="12"
                class="mb-2"
              >
                <div class="title-field">
                  <label> Variable Params </label>
                </div>
                <j-input
                  v-model="dataSetup.container_params"
                  :error-required="false"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12">
                <div class="title-field">
                  <label> Variable Record </label>
                </div>
                <j-input
                  v-model="dataSetup.container_record"
                  :error-required="false"
                  :disabled="true"
                />
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Visibility Condition -->
        <div class="section-field input-field">
          <h4 class="title-section">Visibility Condition</h4>

          <!-- Condition Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Condition</h4>
                <p class="configuration-section-desc">
                  Show action button according to the conditions
                </p>
              </div>

              <!-- Condition Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ selectedOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showConditionOptions = true"
                />

                <!-- Select Condition Operator -->
                <div
                  v-if="showConditionOptions"
                  class="filter-options">
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in conditionOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === selectedOperator }"
                      class="operator-option"
                      @click="closeConditionOptions(operator.id)">
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Condition by Value -->
            <h3 class="configuration-section-subtitle">By Value</h3>
            <div
              v-for="(data, index) in conditionByValue"
              :key="index"
              class="div-filter">
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteConditionValue(index)"
                />
              </div>
              <b-form
                :class="{'error-input': $v.conditionByValue.$each[index].$invalid && !data.key}"
                class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  placeholder="Select Column"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form
                :class="{'error-input': $v.conditionByValue.$each[index].$invalid && !data.value}">
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  placeholder="Input Condition Value"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addConditionValue">
              + Add Parameter
            </div>

            <div
              v-show="!onTable"
              class="separator" />

            <!-- Condition by Function -->
            <h3
              v-show="!onTable"
              class="configuration-section-subtitle">By Function</h3>
            <div
              v-for="(data, index) in conditionByFunction"
              v-show="!onTable"
              :key="index"
              class="div-filter">
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteConditionFunction(index)"
                />
              </div>
              <b-form
                :class="{'error-input': $v.conditionByFunction.$each[index].$invalid && !data.key}"
                class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  placeholder="Select Column"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form
                :class="{'error-input': $v.conditionByFunction.$each[index].$invalid && !data.value}">
                <label> Function </label>
                <j-single-select
                  v-model="data.value"
                  :error-required="false"
                  :options="functionOptions"
                  placeholder="Select Function"
                  label="name"/>
              </b-form>
            </div>

            <div
              v-show="!onTable"
              class="btn-add-config"
              @click="addConditionFunction">
              + Add Parameter
            </div>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div class="properties-field-button">
        <button
          v-if="!fieldDetail"
          class="button-border"
          @click="resetConfiguration"
        >
          <img src="@/assets/new-form-ui/icon/reset.svg">
          Reset
        </button>

        <button
          v-else
          class="button-border"
          @click="deleteActionButton"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, camelcase */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import jwtDecode from 'jwt-decode';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jColorPicker from '@/components/color-picker/jColorPicker';

export default {
  name: 'ActionButtonConfiguration',

  components: {
    jColorPicker,
  },

  mixins: [jMixAutoScroll],

  props: {
    id: {
      type: String,
      default: '',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    onTable: {
      type: Boolean,
      default: () => false,
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dataSetup: {
        key: '',
        icon: '',
        icon_web: '',
        label: '',
        script: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: 'message',
        font_color: '#000000',
        background_color: '#000000',
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
        visibility_condition: {
          operator: 'and',
          variables: [],
        },
      },
      typeOptions: [
        {
          id: 'confirmation',
          name: 'Confirmation',
        },
        {
          id: 'message',
          name: 'Message',
        },
      ],
      conditionOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      showConditionOptions: false,
      conditionByValue: [
        {
          key: null,
          value: null,
        },
      ],
      conditionByFunction: [
        {
          key: null,
          value: null,
        },
      ],
      functionOptions: null,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      selectedOperator: 'and',
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', [
      'showModalScriptActionBtn', 'sourceScriptActionBtn',
      'showModalIconActionBtn', 'sourceIconActionBtn',
    ]),
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetup.key = val ?
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_') : null;
      }, 1);
    },

    showModalScriptActionBtn(val) {
      if (!val) {
        if (this.sourceScriptActionBtn) {
          this.dataSetup.script = this.sourceScriptActionBtn.script;
          this.dataSetup.variable_message = this.sourceScriptActionBtn.variable_message;
          this.dataSetup.variable_redirect = this.sourceScriptActionBtn.variable_redirect;
          this.dataSetup.is_use_confirmation_message = this.sourceScriptActionBtn.is_use_confirmation_message;
          this.dataSetup.custom_confirmation_message = this.sourceScriptActionBtn.custom_confirmation_message;
          this.dataSetup.dynamic_confirmation_message = this.sourceScriptActionBtn.dynamic_confirmation_message;
          this.dataSetup.dynamic_confirmation_message_params = this.sourceScriptActionBtn.dynamic_confirmation_message_params;
        }
      }
    },

    showModalIconActionBtn(val) {
      if (!val) {
        if (this.sourceIconActionBtn) {
          this.dataSetup.icon = this.sourceIconActionBtn.unicode;
          this.dataSetup.icon_web = this.sourceIconActionBtn.facode;
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.visibility_condition.operator': function (val) {
      if (val) {
        this.selectedOperator = val;
      }
    },
  },

  created() {
    this.setPropsData();

    if (this.listFunction && this.listFunction.length > 0) {
      this.functionOptions = this.listFunction;
    } else {
      this.getListFunction();
    }
  },

  methods: {
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalScriptActionButton', 'toggleModalIconActionBtn']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),

    setPropsData() {
      if (this.fieldDetail) {
        this.dataSetup.key = this.fieldDetail.key;
        this.dataSetup.icon = this.fieldDetail.icon;
        this.dataSetup.icon_web = this.fieldDetail.icon_web;
        this.dataSetup.label = this.fieldDetail.label;
        this.dataSetup.script = this.fieldDetail.script;
        this.dataSetup.variable_message = this.fieldDetail.variable_message;
        this.dataSetup.variable_redirect = this.fieldDetail.variable_redirect;
        this.dataSetup.container_params = this.fieldDetail.container_params;
        this.dataSetup.container_record = this.fieldDetail.container_record;
        this.dataSetup.type = this.fieldDetail.type || 'message';
        this.dataSetup.font_color = this.fieldDetail.font_color || '#000000';
        this.dataSetup.background_color = this.fieldDetail.background_color || '#000000';
        this.dataSetup.is_use_confirmation_message = this.fieldDetail.is_use_confirmation_message;
        this.dataSetup.custom_confirmation_message = this.fieldDetail.custom_confirmation_message;
        this.dataSetup.dynamic_confirmation_message = this.fieldDetail.dynamic_confirmation_message;
        this.dataSetup.dynamic_confirmation_message_params = this.fieldDetail.dynamic_confirmation_message_params;
        this.dataSetup.visibility_condition.operator = this.fieldDetail.visibility_condition ? this.fieldDetail.visibility_condition.operator : 'and';
        this.dataSetup.visibility_condition.variables = this.fieldDetail.visibility_condition ? this.fieldDetail.visibility_condition.variables : [];

        this.setVisibilityCondition();
      }
    },

    openModalIcon() {
      this.toggleModalIconActionBtn({ status: true, data: null });
    },

    openModalScript() {
      const data = {
        script: this.dataSetup.script,
        variable_message: this.dataSetup.variable_message,
        variable_redirect: this.dataSetup.variable_redirect,
        is_use_confirmation_message: this.dataSetup.is_use_confirmation_message,
        custom_confirmation_message: this.dataSetup.custom_confirmation_message,
        dynamic_confirmation_message: this.dataSetup.dynamic_confirmation_message,
        dynamic_confirmation_message_params: this.dataSetup.dynamic_confirmation_message_params,
      };

      this.toggleModalScriptActionButton({ status: true, data });
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error && (this.onTable ? !this.$v.conditionByValue.$invalid : (!this.$v.conditionByFunction.$invalid && !this.$v.conditionByValue.$invalid))) {
        const mode = this.fieldDetail ? 'edit' : 'add';
        this.getVisibilityConditionData();
        this.$emit('submit-configuration', mode, this.dataSetup, this.onTable);
      }
    },

    deleteActionButton() {
      this.$emit('delete-action-button', null, this.onTable);
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          key: '',
          icon: '',
          icon_web: '',
          label: '',
          script: '',
          variable_message: '',
          variable_redirect: '',
          container_params: '',
          container_record: '',
          type: null,
          font_color: '#000000',
          background_color: '#000000',
          is_use_confirmation_message: false,
          custom_confirmation_message: '',
          dynamic_confirmation_message: '',
          dynamic_confirmation_message_params: null,
          visibility_condition: {
            operator: 'and',
            variables: [],
          },
        };
      }, 400);
    },

    resetConfiguration() {
      if (this.fieldDetail) {
        this.setPropsData();
      } else {
        this.dataSetup = {
          key: '',
          icon: '',
          icon_web: '',
          label: '',
          script: '',
          variable_message: '',
          variable_redirect: '',
          container_params: '',
          container_record: '',
          type: null,
          font_color: '#000000',
          background_color: '#000000',
          is_use_confirmation_message: false,
          custom_confirmation_message: '',
          dynamic_confirmation_message: '',
          dynamic_confirmation_message_params: null,
          visibility_condition: {
            operator: 'and',
            variables: [],
          },
        };
      }
    },

    closeConditionOptions(id) {
      this.selectedOperator = id;
      this.showConditionOptions = false;
    },

    addConditionValue() {
      this.conditionByValue.push({
        key: null,
        value: null,
      });
    },

    deleteConditionValue(index) {
      this.conditionByValue.splice(index, 1);
    },

    addConditionFunction() {
      this.conditionByFunction.push({
        key: null,
        value: null,
      });
    },

    deleteConditionFunction(index) {
      this.conditionByFunction.splice(index, 1);
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then(({ data }) => {
        this.functionOptions = data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    getVisibilityConditionData() {
      const data = [];
      if (this.conditionByValue.length > 0) {
        this.conditionByValue.forEach((e) => {
          if (e.key && e.value) {
            data.push({
              key: e.key.id,
              operator: 'is',
              value_type: 'value',
              value: e.value,
            });
          }
        });
      }

      if (this.conditionByFunction.length > 0) {
        this.conditionByFunction.forEach((e) => {
          if (e.key && e.value) {
            data.push({
              key: e.key.id,
              operator: 'is',
              value_type: 'function',
              value: e.value,
            });
          }
        });
      }

      if (data.length) {
        this.dataSetup.visibility_condition.variables = data;
        this.dataSetup.visibility_condition.operator = this.selectedOperator;
      } else {
        this.dataSetup.visibility_condition = null;
      }
    },

    setVisibilityCondition() {
      if (this.dataSetup.visibility_condition.variables && this.dataSetup.visibility_condition.variables.length > 0) {
        const dataByValue = [];
        const dataByFunction = [];
        this.dataSetup.visibility_condition.variables.forEach((e) => {
          if (e.value_type === 'value') {
            dataByValue.push({
              key: { id: e.key },
              value: e.value,
            });
          }
          if (e.value_type === 'function') {
            dataByFunction.push({
              key: { id: e.key },
              value: e.value,
            });
          }
        });

        this.conditionByValue = dataByValue.length > 0 ? dataByValue : [{ key: null, value: null }];
        this.conditionByFunction = dataByFunction.length > 0 ? dataByFunction : [{ key: null, value: null }];
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        key: { required },
        icon: { required: requiredIf(() => !this.onTable) },
        icon_web: { required: requiredIf(() => !this.onTable) },
        label: { required },
        script: { },
        variable_message: { },
        variable_redirect: { },
        container_params: { },
        container_record: { },
        type: { },
        visibility_condition: { },
      },
      conditionByValue: {
        $each: {
          key: {
            required: requiredIf(data => data.value),
          },
          value: {
            required: requiredIf(data => data.key && data.key.id),
          },
        },
      },
      conditionByFunction: {
        $each: {
          key: {
            required: requiredIf(data => data.value),
          },
          value: {
            required: requiredIf(data => data.key && data.key.id),
          },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/ActionButtonConfiguration.vue